import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/auth/Login'
import TubeJoin from '@/components/auth/TubeJoin'
import Introduce from '@/components/common/Introduce'
import Gateway from '@/components/gateway/Gateway'
import Authorize from '@/components/auth/Authorize'
import Privacy from '@/components/common/Privacy'
import Terms from '@/components/common/Terms'
import Scene from '@/components/scene/Scene'
import RouteAnalysis from '@/components/juice/RouteAnalysis'
import Device from '@/components/device/Device'
import Kanban from '@/components/juice/Kanban'
import Twins from '@/components/twins/Twins'
import Camera from '@/components/cast/Camera'
import FaceLabeling from '@/components/cast/FaceLabeling'
import Macro from '@/components/reactor/Macro'
import Contact from '@/components/contact/Contact'
import GatewayMap from '@/components/gateway/Map'
import Schedule from '@/components/schedule/Schedule'
import Tracker from '@/components/tracker/Tracker'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'app_name',
    component: Introduce
  }, {
    path: '/login',
    name: 'menu.login',
    component: Login,
    meta: {
      disableToolbar: true
    }
  }, {
    path: '/terms',
    name: 'menu.terms',
    component: Terms
  }, {
    path: '/terms/skype',
    name: 'menu.terms_skype',
    component: Terms
  }, {
    path: '/privacy',
    name: 'menu.privacy',
    component: Privacy
  }, {
    path: '/privacy/skype',
    name: 'menu.privacy_skype',
    component: Privacy
  }, {
    path: '/authorize',
    name: 'menu.authorization',
    component: Authorize,
    meta: {
      disableToolbar: true
    }
  }, {
    path: '/join/:clientId',
    name: 'menu.join',
    component: TubeJoin,
    meta: {
      requiresAuth: true,
      disableToolbar: true
    }
  }, {
    path: '/gateway',
    name: 'menu.my_gateway',
    component: Gateway,
    meta: {
      requiresAuth: true,
      enableSearchKeyword: true
    }
  }, {
    path: '/map',
    name: 'menu.my_gateway_map',
    component: GatewayMap,
    meta: {
      requiresAuth: true,
      enableSearchKeyword: true
    }
  }, {
    path: '/actuator',
    name: 'menu.my_actuator',
    component: Device,
    meta: {
      controllable: true,
      requiresAuth: true,
      enableSearchKeyword: true,
      enableSearchGateway: true,
      enableSearchFuncType: true
    }
  }, {
    path: '/sensor',
    name: 'menu.my_sensor',
    component: Device,
    meta: {
      controllable: false,
      requiresAuth: true,
      enableSearchKeyword: true,
      enableSearchGateway: true,
      enableSearchFuncType: true
    }
  }, {
    path: '/maintain',
    name: 'menu.maintain',
    component: Device,
    meta: {
      maintainable: true,
      requiresAuth: true,
      enableSearchKeyword: true,
      enableSearchGateway: true,
      enableSearchFuncType: true
    }
  }, {
    path: '/scene',
    name: 'menu.my_scene',
    component: Scene,
    meta: {
      requiresAuth: true,
      enableSearchKeyword: true,
      enableSearchGateway: true
    }
  }, {
    path: '/route',
    name: 'menu.route_analysis',
    component: RouteAnalysis,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/kanban',
    name: 'menu.my_kanban',
    component: Kanban,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/twins/:mac',
    name: 'menu.twins',
    component: Twins,
    meta: {
      requiresAuth: true,
      up: true
    }
  }, {
    path: '/camera',
    name: 'menu.my_camera',
    component: Camera,
    meta: {
      requiresAuth: true,
      enableSearchKeyword: true,
      enableSearchGateway: true
    }
  }, {
    path: '/labeling',
    name: 'menu.face_labeling',
    component: FaceLabeling,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/macro',
    name: 'menu.macro',
    component: Macro,
    meta: {
      requiresAuth: true,
      enableSearchKeyword: true,
      enableSearchGateway: true
    }
  }, {
    path: '/contact',
    name: 'menu.contact',
    component: Contact,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/schedule',
    name: 'menu.schedule',
    component: Schedule,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/tracker',
    name: 'menu.tracker',
    component: Tracker,
    meta: {
      requiresAuth: true
    }
  }],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js